module.exports = __webpack_public_path__ + "img/laying-spaccamattone-on.446e2857.svg";